import {makeObservable, observable} from "mobx";

export interface StationDocumentProps {
    label: string;
    url: string;
    isFirstOfCategory: boolean;
}

export class StationDocument {
    @observable label: string;
    @observable url: string;
    @observable isFirstOfCategory: boolean;

    constructor(props?: StationDocumentProps) {
        makeObservable(this);
        if (props) {
            Object.assign(this, props);
        }
    }
}
